import { render, staticRenderFns } from "./BaseLoadingSpinner.vue?vue&type=template&id=5997acab&scoped=true"
import script from "./BaseLoadingSpinner.vue?vue&type=script&lang=js"
export * from "./BaseLoadingSpinner.vue?vue&type=script&lang=js"
import style0 from "./BaseLoadingSpinner.vue?vue&type=style&index=0&id=5997acab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5997acab",
  null
  
)

export default component.exports